<template>
  <!-- MODAL -->
  <div
    class="modal fade"
    id="texto-padrao-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="margin-top: 30px"
    @click.self="cancelModal"
    @keydown.esc="cancelModal"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Cadastrar texto padrão</h4>
            <br />
            <div class="row">
              <div class="col-md-12">
                <div class="card card-primary">
                  <div class="card-header">
                    <h3 class="card-title" style="color: white">Cadastrar</h3>
                  </div>

                  <div class="card-body">
                    <div class="row">
                      <!-- NOME -->
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="exampleInputEmail1">Título</label>
                          <input class="form-control" v-model="formData.titulo" />

                          <span style="color: red" v-for="error in v$.titulo.$errors" :key="error.$uid">
                            {{ error.$message }}
                          </span>
                        </div>
                      </div>

                      <!-- NOME CONTATO -->
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="nome_contato">Conteúdo</label>
                          <input class="form-control" v-model="formData.conteudo" />

                          <span style="color: red" v-for="error in v$.conteudo.$errors" :key="error.$uid">
                            {{ error.$message }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-footer">
                    <button type="submit" class="btn btn-primary" @click="validateFields()" style="margin-right: 15px">Cadastrar</button>

                    <button class="btn btn-danger" @click="this.setCriarTexto(false)">Fechar</button>
                    <button hidden data-toggle="modal" data-target="#texto-padrao-modal" id="fechar_texto_modal" class="btn btn-danger">
                      Fechar 2
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import Editor from "primevue/editor";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";
import useVueLidate from "@vuelidate/core";

export default {
  props: ["textoCriado", "setCriarTexto"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading, Editor },

  data() {
    return {
      isLoading: false,
      paginas: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      mail_selecionado: "",
      assunto: "",
      corpo: "",
      corpo_text: "",
      texto_teste: "",
      cco: "",
      to: "",
      mail_templates: "",
      data_teste: "Testando data",
      texto_selecionado: "",
      exibir_texto_padrao: false,
      cadastrar_comitente: false,
    };
  },

  setup() {
    const formData = reactive({
      titulo: "",
      conteudo: "",
    });

    const rules = computed(() => {
      let local_rules = { titulo: { required }, conteudo: { required } };

      return local_rules;
    });

    const minDate = (date) => {
      return new Date(date) >= new Date();
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log("Criando texto");

    this.total = this.mail_templates.length;

    document.getElementById("fechar_texto_modal").click();
  },

  methods: {
    cancelModal() {
      this.setCriarTexto(false);
    },

    async validateFields() {
      const result = await this.v$.$validate();

      if (result) {
        this.store();
      }
    },

    store() {
      this.isLoading = true;

      let data = {
        titulo: this.formData.titulo,
        conteudo: this.formData.conteudo,
      };

      console.log("Cadastrando");
      console.log(data);

      axios
        .post(`/admin/texto_padrao/store`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessage("Sucesso", "Texto cadastrado");

          this.textoCriado(data);
        })
        .catch((error) => {
          this.isLoading = false;
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
